import { handleAction } from 'uix/actions';
import log from 'uix/logging';
import { dict, isArray } from 'ldash';
// ---Local imports
import { setCfgOcr } from './actions';
export const config = [
    handleAction(setCfgOcr, (config, { payload })=>{
        return {
            ...config,
            ocr: isArray(payload.cfg.ocr) ? dict(payload.cfg.ocr.map((e)=>[
                    e.coid,
                    e
                ])) : payload.cfg
        };
    }, {
        ocr: null
    } // initial state
    )
];
